// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gQ","advertCardNum":"c-a_gR"};